class MainArticle extends HTMLElement {
    constructor() {
      super();
      this._summaryBuilt = false;
    }
  
    connectedCallback() {
      this.buildSummary();
      this.processVideos(); 
      this.processButtons();
      this.initSlider();
    }

    initSlider() {
      this.swiper = new Swiper('.artile-slide__product.swiper', {
        slidesPerView: 2.1,
        spaceBetween: 6,
        breakpoints: {
          989: {
            slidesPerView: 3,
            spaceBetween: 0,
          }
        },
        pagination: {
          el: '.artile-slide__product .swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.artile-slide__product .swiper-btn-next',
          prevEl: '.artile-slide__product .swiper-btn-prev',
        }
      });
    }
  
    /* ---------- SOMMAIRE ---------- */
  
    buildSummary() {
      if (this._summaryBuilt) return;
    
      // On prend tout le contenu texte (article + liste produits + richtext)
      const content = this.querySelector('.article__content-container');
      const summary = this.querySelector('.article__summary');
    
      if (!content || !summary) return;
    
      // On prend tous les h2/h3 dans cette colonne
      const headings = content.querySelectorAll('h2, h3');
    
      if (!headings.length) {
        summary.style.display = 'none';
        return;
      }
    
      this._summaryBuilt = true;
    
      const usedIds = new Set();
    
      const slugify = (text) => {
        return text
          .toLowerCase()
          .trim()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '') // accents
          .replace(/[^a-z0-9\s-]/g, '')    // caractères spéciaux
          .replace(/\s+/g, '-');           // espaces -> tirets
      };
    
      summary.innerHTML = '';
    
      const title = document.createElement('p');
      title.className = 'article-summary__title';
      title.textContent = 'Sommaire';
      summary.appendChild(title);
    
      const list = document.createElement('ul');
      list.className = 'article-summary__list';
    
      headings.forEach((heading, index) => {
        const level = heading.tagName.toLowerCase();
    
        if (!heading.id) {
          let baseId = slugify(heading.textContent) || `section-${index + 1}`;
          let uniqueId = baseId;
          let i = 1;
          while (usedIds.has(uniqueId)) {
            uniqueId = `${baseId}-${i++}`;
          }
          usedIds.add(uniqueId);
          heading.id = uniqueId;
        }
    
        const li = document.createElement('li');
        li.className = `article-summary__item article-summary__item--${level}`;
    
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'article-summary__link';
        button.textContent = heading.textContent;
    
        button.addEventListener('click', () => {
          this.scrollToHeading(heading);
        });
    
        li.appendChild(button);
        list.appendChild(li);
      });
    
      summary.appendChild(list);
    }
    
  
    scrollToHeading(heading) {
      const headerOffset = 105; // ajuste selon ton header sticky
      const rect = heading.getBoundingClientRect();
      const offsetTop = rect.top + window.scrollY - headerOffset;
  
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      });
    }
  
    /* ---------- SHORTCODE [youtube url="..." alignement="..."] ---------- */
  
    processVideos() {
      const body = this.querySelector('.article__body');
      if (!body) return;
    
      // Shortcode : [youtube url="..." alignement="left|center|right"]
      // (pas de closing tag)
      const shortcodeRegex = /\[youtube\s+([^\]]*)\]/gi;
    
      const ensureHttp = (url) => {
        const u = (url || '').trim();
        if (!u) return '';
        if (/^https?:\/\//i.test(u)) return u;
        return `https://${u}`;
      };
    
      const stripHtml = (s) => (s || '').replace(/<[^>]*>/g, ' ');
    
      const extractYoutubeUrlFromAttrs = (attrString) => {
        const cleaned = stripHtml(attrString).replace(/\s+/g, ' ').trim();
    
        // url="..."
        const m1 = cleaned.match(/url="([^"]+)"/i);
        if (m1?.[1]) return ensureHttp(m1[1]);
    
        // url='...'
        const m2 = cleaned.match(/url='([^']+)'/i);
        if (m2?.[1]) return ensureHttp(m2[1]);
    
        // sinon : première URL http(s)
        const m3 = cleaned.match(/https?:\/\/[^\s"]+/i);
        if (m3?.[0]) return m3[0].trim();
    
        return '';
      };
    
      const extractAlignFromAttrs = (attrString) => {
        const cleaned = stripHtml(attrString);
        const m = cleaned.match(/alignement="(left|center|right)"/i);
        return m ? m[1] : 'left';
      };
    
      // Construit un mapping index -> {node, offset} pour créer un Range fiable
      const buildIndexMap = (rootEl) => {
        const walker = document.createTreeWalker(rootEl, NodeFilter.SHOW_TEXT, null);
        const map = [];
        let flat = '';
        let node;
    
        while ((node = walker.nextNode())) {
          const t = node.nodeValue || '';
          for (let i = 0; i < t.length; i++) map.push({ node, offset: i });
          flat += t;
        }
    
        map.push({ node: null, offset: 0 }); // sentinelle fin
        return { flat, map };
      };
    
      // On cible les <p> (ton contenu Shopify met le shortcode dedans)
      const paragraphs = body.querySelectorAll('p');
      paragraphs.forEach((p) => {
        if (!p.textContent.includes('[youtube')) return;
    
        const { flat, map } = buildIndexMap(p);
        if (!flat.includes('[youtube')) return;
    
        const matches = [...flat.matchAll(shortcodeRegex)];
        if (!matches.length) return;
    
        // On remplace de la fin vers le début
        for (let i = matches.length - 1; i >= 0; i--) {
          const match = matches[i];
          const full = match[0];
          const attrString = match[1] || '';
    
          const startIndex = match.index;
          const endIndex = startIndex + full.length;
    
          if (startIndex == null || startIndex < 0 || endIndex > map.length) continue;
    
          const rawUrl = extractYoutubeUrlFromAttrs(attrString);
          const align = extractAlignFromAttrs(attrString);
          const videoId = this.extractYoutubeId(rawUrl);
    
          // Si pas d'ID valide, on ne casse pas le contenu : on skip
          if (!videoId) continue;
    
          // Crée l’iframe
          const wrapper = document.createElement('div');
          wrapper.className = `article-video-wrapper article-video-wrapper--${align}`;
    
          const videoContainer = document.createElement('div');
          videoContainer.className = 'article__video';
    
          const iframe = document.createElement('iframe');
          iframe.src = `https://www.youtube.com/embed/${videoId}`;
          iframe.title = 'YouTube video player';
          iframe.setAttribute('frameborder', '0');
          iframe.setAttribute(
            'allow',
            'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
          );
          iframe.setAttribute('allowfullscreen', 'true');
          iframe.loading = 'lazy';
    
          videoContainer.appendChild(iframe);
          wrapper.appendChild(videoContainer);
    
          // Remplacement précis via Range
          const range = document.createRange();
    
          const startPos = map[startIndex];
          const endPos = map[endIndex - 1];
          if (!startPos?.node || !endPos?.node) continue;
    
          range.setStart(startPos.node, startPos.offset);
          range.setEnd(endPos.node, endPos.offset + 1);
    
          range.deleteContents();
          range.insertNode(wrapper);
          range.detach();
        }
      });
    }
    
    
  
    extractYoutubeId(value) {
      if (!value) return null;
  
      // Si c'est déjà un ID simple
      if (/^[a-zA-Z0-9_-]{11}$/.test(value)) {
        return value;
      }
  
      try {
        const url = new URL(value);
  
        // ?v=ID
        const vParam = url.searchParams.get('v');
        if (vParam && /^[a-zA-Z0-9_-]{11}$/.test(vParam)) {
          return vParam;
        }
  
        // youtu.be/ID
        const shortMatch = url.pathname.match(/^\/([a-zA-Z0-9_-]{11})/);
        if (shortMatch) return shortMatch[1];
  
        // /embed/ID
        const embedMatch = url.pathname.match(/\/embed\/([a-zA-Z0-9_-]{11})/);
        if (embedMatch) return embedMatch[1];
  
        return null;
      } catch (e) {
        // Si ce n'est pas une URL valide, on tente quand même un ID
        if (/^[a-zA-Z0-9_-]{11}$/.test(value)) {
          return value;
        }
        return null;
      }
    }
  
    /* ---------- SHORTCODE [button url="..." alignement="..."]Texte[/button] ---------- */
  
    processButtons() {
      const body = this.querySelector('.article__body');
      if (!body) return;
    
      // Match sur un "texte plat" (peut couvrir plusieurs spans / textNodes)
      const shortcodeRegex = /\[button\s+([^\]]*)\]([\s\S]*?)\[\/button\]/gi;
    
      // On limite aux paragraphes (c’est là que Shopify met souvent le contenu)
      const paragraphs = body.querySelectorAll('p');
      if (!paragraphs.length) return;
    
      const ensureHttp = (url) => {
        const u = (url || '').trim();
        if (!u) return '#';
        if (/^https?:\/\//i.test(u)) return u;
        return `https://${u}`;
      };
    
      const parseAttrs = (attrString) => {
        const urlMatch = attrString.match(/url="([^"]+)"/i);
        const alignMatch = attrString.match(/alignement="(left|center|right)"/i);
    
        return {
          url: ensureHttp(urlMatch ? urlMatch[1] : '#'),
          align: alignMatch ? alignMatch[1] : 'left',
        };
      };
    
      // Construit un mapping index -> { node, offset } pour pouvoir créer un Range
      const buildIndexMap = (rootEl) => {
        const walker = document.createTreeWalker(rootEl, NodeFilter.SHOW_TEXT, null);
        const map = [];
        let flat = '';
        let node;
    
        while ((node = walker.nextNode())) {
          const text = node.nodeValue || '';
          for (let i = 0; i < text.length; i++) {
            map.push({ node, offset: i });
          }
          flat += text;
        }
    
        // position "fin" (utile quand on veut range jusqu'à la fin d'un textNode)
        map.push({ node: null, offset: 0 });
        return { flat, map };
      };
    
      // On traite paragraphe par paragraphe
      paragraphs.forEach((p) => {
        // Petit guard : si pas de "[button" dans le texte du <p>, on skip
        if (!p.textContent.includes('[button')) return;
    
        const { flat, map } = buildIndexMap(p);
        if (!flat.includes('[button') || !flat.includes('[/button]')) return;
    
        // IMPORTANT : si plusieurs shortcodes dans le même <p>, on remplace de la fin vers le début
        const matches = [...flat.matchAll(shortcodeRegex)];
        if (!matches.length) return;
    
        for (let m = matches.length - 1; m >= 0; m--) {
          const match = matches[m];
    
          const full = match[0];
          const attrString = match[1] || '';
          const labelRaw = (match[2] || '').trim();
    
          const startIndex = match.index;
          const endIndex = startIndex + full.length; // exclu
    
          // Sécurité : si indexes hors map (rare), on skip
          if (startIndex == null || startIndex < 0 || endIndex > map.length) continue;
    
          const { url, align } = parseAttrs(attrString);
          const label = labelRaw || 'Voir plus';
    
          // Crée le bouton final (ton HTML "safe")
          const wrapper = document.createElement('div');
          wrapper.className = `article-button-wrapper article-button-wrapper--${align}`;
    
          const btn = document.createElement('a');
          btn.className = 'article-button button--primary button';
          btn.href = url;
          btn.textContent = label;
          btn.target = '_blank';
          btn.rel = 'noopener noreferrer';
    
          wrapper.appendChild(btn);
    
          // Remplacement précis via Range
          const range = document.createRange();
    
          // start
          const startPos = map[startIndex];
          if (!startPos || !startPos.node) continue;
          range.setStart(startPos.node, startPos.offset);
    
          // end (endIndex est exclu, donc on met end à l’index précédent + 1)
          const endPos = map[endIndex - 1];
          if (!endPos || !endPos.node) continue;
          range.setEnd(endPos.node, endPos.offset + 1);
    
          range.deleteContents();
          range.insertNode(wrapper);
          range.detach();
        }
      });
    }
    
  }
  
  customElements.define('main-article', MainArticle);
  